import {easepick} from '@easepick/core';
import {RangePlugin} from '@easepick/range-plugin';
import {LockPlugin} from '@easepick/lock-plugin';
import {PresetPlugin} from '@easepick/preset-plugin';
import moment from "moment";

/**
 * Get current lang
 * @returns {string}
 */
export const getCurrentLang = () => {
    return new URL(window.location.href).pathname.split('/')[1];
}

/**
 * Set the locale for moment
 */
moment.locale(getCurrentLang())

let easypick;

/**
 *
 * @returns {Core|*}
 */
export const getDatePicker = () => {
    if (!easypick) {
        let current_lang = getCurrentLang();
        const easepickCssLocation = window.easepickCssLocation;
        const isMobile = window.matchMedia("(max-width: 800px)").matches;

        easypick = new easepick.create({
            element: document.getElementById('date-input'),
            css: [
                easepickCssLocation,
            ],
            zIndex: 11,
            format: "DD/MM/YYYY",
            plugins: [RangePlugin, LockPlugin, PresetPlugin],
            autoApply: !isMobile,
            lang: current_lang,
            locale: {
                cancel: window.jsTranslations['cancel'],
                apply: window.jsTranslations['apply']
            },
            grid: isMobile ? 2 : 3,
            calendars: isMobile ? 1 : 2,
            RangePlugin: {
                delimiter: ' ⟶ ',
                tooltip: false,
            },
            LockPlugin: {
                selectBackward: false,
                minDate: new Date(),
            },
            PresetPlugin: {
                position: isMobile ? 'top' : 'left',
            },
            setup(picker) {
                picker.on('render', () => {
                   setupTimePeriodCards()
                })
            }
        });
    }
    return easypick;
}

/**
 * Display notification with success, error or information message
 * @param notification
 */
export function displayNotification(notification) {
    let notifbar = notification.querySelector('.notif-bar');

    notification.style.display = 'block';
    notifbar.style.width = '100%';
    notification.style.opacity = '0';

    setTimeout(() => {
        notification.style.opacity = '1';
        notifbar.style.width = '0%';
    }, 1);

    setTimeout(() => {
        notification.style.opacity = '0';
    }, 5000);

    setTimeout(() => {
        notifbar.style.width = '100%';
        notification.style.display = 'none';
    }, 5200);
}

function formatDateRange(startDate, endDate) {
    if (startDate === endDate || !endDate) return `${startDate.format('D MMMM')}`
    if (startDate.month() === endDate.month() && startDate.year() === endDate.year()) {
        return `${startDate.format('D')} – ${endDate.format('D MMMM')}`;
    } else {
        return `${startDate.format('D MMMM')} – ${endDate.format('D MMMM')}`;
    }
}

function createTimePeriodCardElement(url, title, startDate, endDate) {
    const dateRange = formatDateRange(startDate, endDate);
    const card = document.createElement('div');
    const isCurrPage = window.location.pathname.endsWith(url);
    card.classList.add('preset-card', 'time-period-card-'+url)
    card.setAttribute('data-title', title);
    card.setAttribute('data-slug', url);
    card.setAttribute('period-search-start', startDate.format('DD/MM/YYYY'));
    card.setAttribute('period-search-end', endDate.format('DD/MM/YYYY'));
    if (isCurrPage) {
        card.className += ' period-search-selected';
        const datesInput = document.getElementById('date-input');
        if (datesInput) {
            datesInput.setAttribute('placeholder', title);
        }
    }
    card.innerHTML = `
    <h3 class="card-header">${title}</h3>
    <div class="card-content">${dateRange}</div>
    `;
    card.addEventListener('click', (event) => {
        event.preventDefault();
        document.querySelector('.easepick-wrapper').click();
        if (document.querySelector('.home-page')) {
            window.location.href = '/' + getCurrentLang() + '/' + url;
        } else {
            document.dispatchEvent(new CustomEvent("timePeriodCardSelected", {
                detail: {
                    slug: url,
                },
            }));
        }
    })
    return card;
}

/**
 * Creates and appends date-specific cards to a calendar UI based on the day of the week.
 *
 * @param {Date} today - The current date from which other dates are calculated.
 */
function setupTimePeriodCards() {
    const presetsContainer = document.querySelector('.easepick-wrapper').shadowRoot.querySelector('.preset-plugin-container');
    presetsContainer.innerHTML = ''; // Clear any existing content

    const today = moment().startOf('day');

    // Create elements for today and tomorrow
    const todayCard = createTimePeriodCardElement(window.jsTranslations['today-url'], window.jsTranslations['today'], today, today);
    const tomorrow = today.clone().add(1, 'day');
    const tomorrowCard = createTimePeriodCardElement(window.jsTranslations['tomorrow-url'], window.jsTranslations['tomorrow'], tomorrow, tomorrow);

    // Calculate the start and end dates for the current or next week
    let weekTitle = window.jsTranslations['this_week'];
    let startOfWeek = today.clone().startOf('week');
    if (today.isoWeekday() >= 5) {
        startOfWeek = startOfWeek.add(1, 'week');
        weekTitle = window.jsTranslations['next_week'];
    }
    let endOfWeek = startOfWeek.clone().endOf('week');
    const weekCard = createTimePeriodCardElement(window.jsTranslations['this-week-url'], weekTitle, startOfWeek, endOfWeek);

    // Calculate the start and end dates for this or next weekend
    let weekendTitle = window.jsTranslations['this_weekend'];
    let startOfWeekend = today.clone().isoWeekday(5);
    if (today.isoWeekday() === 7) { // If today is Sunday
        startOfWeekend = startOfWeekend.add(1, 'week');
        weekendTitle = window.jsTranslations['next_weekend'];
    }
    const endOfWeekend = startOfWeekend.clone().endOf('week')
    const weekendCard = createTimePeriodCardElement(window.jsTranslations['this-weekend-url'], weekendTitle, startOfWeekend, endOfWeekend);

    presetsContainer.appendChild(todayCard);
    presetsContainer.appendChild(tomorrowCard);

    if (today.isoWeekday() === 5 || today.isoWeekday() === 6) { // Put weekend before week during friday/saturday
        presetsContainer.appendChild(weekendCard);
        presetsContainer.appendChild(weekCard);
    } else {
        presetsContainer.appendChild(weekCard);
        presetsContainer.appendChild(weekendCard);
    }
}
